(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-footer"] && !Shopify.designMode) return;
  try {
    
(() => {
 if(customElements.get('mes-reference-cart')) return;
 class MesReferenceCart extends HTMLElement {
  connectedCallback(){
   this.abort=new AbortController();this.dialog=this.querySelector('dialog');this.busy=false;this.sequence=0;
   const on=(el,event,fn,options={})=>el.addEventListener(event,fn,{...options,signal:this.abort.signal});
   on(this,'click',e=>{const b=e.target.closest('button');if(!b)return;if(b.hasAttribute('data-close'))return this.close();const row=b.closest('[data-key]');if(b.hasAttribute('data-quantity-to'))this.mutate('change',{id:row.dataset.key,quantity:Number(b.dataset.quantityTo)});if(b.hasAttribute('data-subscribe'))this.mutate('change',{line:Number(row.dataset.line),quantity:Number(row.dataset.quantity),selling_plan:Number(row.querySelector('select').value)});if(b.hasAttribute('data-add'))this.mutate('add',{items:[{id:Number(b.dataset.add),quantity:1}]});});
   on(this.dialog,'click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right)this.close();}});
   on(this.dialog,'close',()=>{if(this.savedOverflow!==undefined){document.body.style.overflow=this.savedOverflow;this.savedOverflow=undefined;}this.opener?.focus?.();});
   on(document,'click',e=>{const a=e.target.closest('a[href], [data-mes-cart-open]');if(!a||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;const url=a.getAttribute('href');if(!a.hasAttribute('data-mes-cart-open')&&(!url||new URL(url,location.href).pathname.replace(/\/$/,'')!==(this.dataset.root+'cart').replace(/\/$/,'')))return;e.preventDefault();e.stopImmediatePropagation();this.open();this.refresh();},{capture:true});
   on(document,'mes:cart:open',()=>{this.open();this.refresh();});
   if(this.dataset.intercept==='true')on(document,'submit',e=>{const form=e.target;if(!(form instanceof HTMLFormElement)||!form.querySelector('[name="id"]')||!new URL(form.action,location.href).pathname.match(/\/cart\/add(?:\.js)?$/))return;e.preventDefault();e.stopImmediatePropagation();if(this.busy)return;this.open();this.mutate('add',new FormData(form));},{capture:true});
   on(document,'shopify:section:select',e=>{if(e.detail.sectionId===this.dataset.section)this.open();});
  }
  open(){if(this.dialog.open)return;this.opener=document.activeElement;this.savedOverflow=document.body.style.overflow;document.body.style.overflow='hidden';this.dialog.showModal();this.querySelector('[data-close]').focus();}
  close(){this.dialog.close();}
  error(message){const p=this.querySelector('.mc-error');p.textContent=message;p.hidden=false;}
  async refresh(){const seq=++this.sequence;try{const u=new URL(this.dataset.root,location.origin);u.searchParams.set('sections',this.dataset.section);const response=await fetch(u,{cache:'no-store'});if(!response.ok)throw Error('Warenkorb konnte nicht geladen werden.');const data=await response.json();if(seq!==this.sequence)return;const doc=new DOMParser().parseFromString(data[this.dataset.section]||'','text/html');const content=doc.querySelector('[data-mc-content]');if(!content)throw Error('Warenkorb konnte nicht geladen werden. Bitte Seite neu laden.');const oldScroll=this.querySelector('.mc-scroll').scrollTop;const focused=this.contains(document.activeElement);this.querySelector('[data-mc-content]').replaceWith(content);this.querySelector('.mc-scroll').scrollTop=oldScroll;if(focused)this.querySelector('[data-close]').focus({preventScroll:true});document.querySelectorAll('[data-cart-count]').forEach(el=>{el.textContent=content.dataset.count;el.hidden=Number(content.dataset.count)===0;});}catch(e){this.error(e.message);}}
  async mutate(action,payload){if(this.busy)return;this.busy=true;this.querySelector('.mc-error').hidden=true;this.setAttribute('aria-busy','true');this.querySelectorAll('button:not([data-close])').forEach(b=>b.disabled=true);try{const form=payload instanceof FormData;const response=await fetch(this.dataset.root+'cart/'+action+'.js',{method:'POST',headers:form?{Accept:'application/json'}:{'Content-Type':'application/json',Accept:'application/json'},body:form?payload:JSON.stringify(payload)});const data=await response.json();if(!response.ok||data.status>=400)throw Error(data.description||data.message||'Der Warenkorb konnte nicht aktualisiert werden.');await this.refresh();document.dispatchEvent(new CustomEvent('mes:cart:updated'));}catch(e){this.error(e.message);}finally{this.busy=false;this.removeAttribute('aria-busy');this.querySelectorAll('button').forEach(b=>b.disabled=false);}}
  disconnectedCallback(){this.abort?.abort();if(this.dialog?.open)this.close();if(this.savedOverflow!==undefined)document.body.style.overflow=this.savedOverflow;}
 }
 customElements.define('mes-reference-cart',MesReferenceCart);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-cart-items"] && !Shopify.designMode) return;
  try {
    
(() => {
 if(customElements.get('mes-reference-cart')) return;
 class MesReferenceCart extends HTMLElement {
  connectedCallback(){
   this.abort=new AbortController();this.dialog=this.querySelector('dialog');this.busy=false;this.sequence=0;
   const on=(el,event,fn,options={})=>el.addEventListener(event,fn,{...options,signal:this.abort.signal});
   on(this,'click',e=>{const b=e.target.closest('button');if(!b)return;if(b.hasAttribute('data-close'))return this.close();const row=b.closest('[data-key]');if(b.hasAttribute('data-quantity-to'))this.mutate('change',{id:row.dataset.key,quantity:Number(b.dataset.quantityTo)});if(b.hasAttribute('data-subscribe'))this.mutate('change',{line:Number(row.dataset.line),quantity:Number(row.dataset.quantity),selling_plan:Number(row.querySelector('select').value)});if(b.hasAttribute('data-add'))this.mutate('add',{items:[{id:Number(b.dataset.add),quantity:1}]});});
   on(this.dialog,'click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right)this.close();}});
   on(this.dialog,'close',()=>{if(this.savedOverflow!==undefined){document.body.style.overflow=this.savedOverflow;this.savedOverflow=undefined;}this.opener?.focus?.();});
   on(document,'click',e=>{const a=e.target.closest('a[href], [data-mes-cart-open]');if(!a||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;const url=a.getAttribute('href');if(!a.hasAttribute('data-mes-cart-open')&&(!url||new URL(url,location.href).pathname.replace(/\/$/,'')!==(this.dataset.root+'cart').replace(/\/$/,'')))return;e.preventDefault();e.stopImmediatePropagation();this.open();this.refresh();},{capture:true});
   on(document,'mes:cart:open',()=>{this.open();this.refresh();});
   if(this.dataset.intercept==='true')on(document,'submit',e=>{const form=e.target;if(!(form instanceof HTMLFormElement)||!form.querySelector('[name="id"]')||!new URL(form.action,location.href).pathname.match(/\/cart\/add(?:\.js)?$/))return;e.preventDefault();e.stopImmediatePropagation();if(this.busy)return;this.open();this.mutate('add',new FormData(form));},{capture:true});
   on(document,'shopify:section:select',e=>{if(e.detail.sectionId===this.dataset.section)this.open();});
  }
  open(){if(this.dialog.open)return;this.opener=document.activeElement;this.savedOverflow=document.body.style.overflow;document.body.style.overflow='hidden';this.dialog.showModal();this.querySelector('[data-close]').focus();}
  close(){this.dialog.close();}
  error(message){const p=this.querySelector('.mc-error');p.textContent=message;p.hidden=false;}
  async refresh(){const seq=++this.sequence;try{const u=new URL(this.dataset.root,location.origin);u.searchParams.set('sections',this.dataset.section);const response=await fetch(u,{cache:'no-store'});if(!response.ok)throw Error('Warenkorb konnte nicht geladen werden.');const data=await response.json();if(seq!==this.sequence)return;const doc=new DOMParser().parseFromString(data[this.dataset.section]||'','text/html');const content=doc.querySelector('[data-mc-content]');if(!content)throw Error('Warenkorb konnte nicht geladen werden. Bitte Seite neu laden.');const oldScroll=this.querySelector('.mc-scroll').scrollTop;const focused=this.contains(document.activeElement);this.querySelector('[data-mc-content]').replaceWith(content);this.querySelector('.mc-scroll').scrollTop=oldScroll;if(focused)this.querySelector('[data-close]').focus({preventScroll:true});document.querySelectorAll('[data-cart-count]').forEach(el=>{el.textContent=content.dataset.count;el.hidden=Number(content.dataset.count)===0;});}catch(e){this.error(e.message);}}
  async mutate(action,payload){if(this.busy)return;this.busy=true;this.querySelector('.mc-error').hidden=true;this.setAttribute('aria-busy','true');this.querySelectorAll('button:not([data-close])').forEach(b=>b.disabled=true);try{const form=payload instanceof FormData;const response=await fetch(this.dataset.root+'cart/'+action+'.js',{method:'POST',headers:form?{Accept:'application/json'}:{'Content-Type':'application/json',Accept:'application/json'},body:form?payload:JSON.stringify(payload)});const data=await response.json();if(!response.ok||data.status>=400)throw Error(data.description||data.message||'Der Warenkorb konnte nicht aktualisiert werden.');await this.refresh();document.dispatchEvent(new CustomEvent('mes:cart:updated'));}catch(e){this.error(e.message);}finally{this.busy=false;this.removeAttribute('aria-busy');this.querySelectorAll('button').forEach(b=>b.disabled=false);}}
  disconnectedCallback(){this.abort?.abort();if(this.dialog?.open)this.close();if(this.savedOverflow!==undefined)document.body.style.overflow=this.savedOverflow;}
 }
 customElements.define('mes-reference-cart',MesReferenceCart);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mes-animated-stats"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mes-animated-stats'))customElements.define('mes-animated-stats',class extends HTMLElement{
connectedCallback(){
this.counters=[...this.querySelectorAll('[data-counter]')];this.frames=new Map();this.finished=new Set();this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.abort=new AbortController();
this.motion.addEventListener('change',()=>{if(this.motion.matches)this.finishAll()},{signal:this.abort.signal});
if(this.motion.matches||!('IntersectionObserver'in window)){this.finishAll();return}
this.observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){this.animate(entry.target);this.observer.unobserve(entry.target)}})},{threshold:.45});
this.counters.forEach(counter=>this.observer.observe(counter));
}
animate(counter){
if(this.finished.has(counter))return;this.finished.add(counter);const target=Number(counter.dataset.target);if(!Number.isFinite(target))return;
const decimals=(counter.dataset.target.split('.')[1]||'').length;const duration=Number(this.dataset.duration)||1600;let start;
const tick=time=>{if(start===undefined)start=time;const progress=Math.min((time-start)/duration,1);const eased=1-Math.pow(1-progress,3);counter.textContent=(target*eased).toFixed(decimals);if(progress<1)this.frames.set(counter,requestAnimationFrame(tick));else{counter.textContent=counter.dataset.target;this.frames.delete(counter)}};
this.frames.set(counter,requestAnimationFrame(tick));
}
finishAll(){this.observer?.disconnect();this.frames?.forEach(frame=>cancelAnimationFrame(frame));this.frames?.clear();this.counters.forEach(counter=>{counter.textContent=counter.dataset.target;this.finished.add(counter)})}
disconnectedCallback(){this.finishAll();this.abort?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mes-breathe-stats"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mes-breathe-stats'))customElements.define('mes-breathe-stats',class extends HTMLElement{
connectedCallback(){
this.counters=[...this.querySelectorAll('[data-counter]')];this.frames=new Map();this.finished=new Set();this.motion=matchMedia('(prefers-reduced-motion: reduce)');this.abort=new AbortController();
this.motion.addEventListener('change',()=>{if(this.motion.matches)this.finishAll()},{signal:this.abort.signal});
if(this.motion.matches||!('IntersectionObserver'in window)){this.finishAll();return}
this.observer=new IntersectionObserver(entries=>{entries.forEach(entry=>{if(entry.isIntersecting){this.animate(entry.target);this.observer.unobserve(entry.target)}})},{threshold:.45});
this.counters.forEach(counter=>this.observer.observe(counter));
}
animate(counter){
if(this.finished.has(counter))return;this.finished.add(counter);const target=Number(counter.dataset.target);if(!Number.isFinite(target))return;
const decimals=(counter.dataset.target.split('.')[1]||'').length;const duration=Number(this.dataset.duration)||1600;let start;
const tick=time=>{if(start===undefined)start=time;const progress=Math.min((time-start)/duration,1);const eased=1-Math.pow(1-progress,3);counter.textContent=(target*eased).toFixed(decimals);if(progress<1)this.frames.set(counter,requestAnimationFrame(tick));else{counter.textContent=counter.dataset.target;this.frames.delete(counter)}};
this.frames.set(counter,requestAnimationFrame(tick));
}
finishAll(){this.observer?.disconnect();this.frames?.forEach(frame=>cancelAnimationFrame(frame));this.frames?.clear();this.counters.forEach(counter=>{counter.textContent=counter.dataset.target;this.finished.add(counter)})}
disconnectedCallback(){this.finishAll();this.abort?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mes-cart-drawer"] && !Shopify.designMode) return;
  try {
    
(() => {
 if(customElements.get('mes-reference-cart')) return;
 // Observe completed same-origin additions; preserve request payloads and responses.
 // This supports custom product/bundle scripts that do not submit a standard form.
 if(!window.__mesCartAddObserver){
  window.__mesCartAddObserver=true;
  const originalFetch=window.fetch;
  window.fetch=async function(input,options){
   const response=await originalFetch.apply(this,arguments);
   try{
    const requestURL=input instanceof Request?input.url:input;
    const url=new URL(requestURL,location.href);
    const method=String(options?.method||(input instanceof Request?input.method:'GET')).toUpperCase();
    if(method==='POST'&&url.origin===location.origin&&/\/cart\/add(?:\.js)?\/?$/.test(url.pathname)&&response.ok){
     response.clone().json().then(data=>{
      if(!data||Number(data.status)>=400||data.errors)return;
      document.dispatchEvent(new CustomEvent('mes:cart:network-added'));
     }).catch(()=>{});
    }
   }catch(_){}
   return response;
  };
 }
 class MesReferenceCart extends HTMLElement {
  connectedCallback(){
   this.abort=new AbortController();this.dialog=this.querySelector('dialog');this.busy=false;this.sequence=0;
   const on=(el,event,fn,options={})=>el.addEventListener(event,fn,{...options,signal:this.abort.signal});
   on(this,'click',e=>{const b=e.target.closest('button');if(!b)return;if(b.hasAttribute('data-close'))return this.close();const row=b.closest('[data-key]');if(b.hasAttribute('data-quantity-to'))this.mutate('change',{id:row.dataset.key,quantity:Number(b.dataset.quantityTo)});if(b.hasAttribute('data-subscribe'))this.mutate('change',{line:Number(row.dataset.line),quantity:Number(row.dataset.quantity),selling_plan:Number(row.querySelector('select').value)});if(b.hasAttribute('data-add'))this.mutate('add',{items:[{id:Number(b.dataset.add),quantity:1}]});});
   on(this.dialog,'click',e=>{if(e.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right)this.close();}});
   on(this.dialog,'close',()=>{if(this.savedOverflow!==undefined){document.body.style.overflow=this.savedOverflow;this.savedOverflow=undefined;}this.opener?.focus?.();});
   on(document,'click',e=>{const a=e.target.closest('a[href], [data-mes-cart-open]');if(!a||e.ctrlKey||e.metaKey||e.shiftKey||e.altKey)return;const url=a.getAttribute('href');if(!a.hasAttribute('data-mes-cart-open')&&(!url||new URL(url,location.href).pathname.replace(/\/$/,'')!==(this.dataset.root+'cart').replace(/\/$/,'')))return;e.preventDefault();e.stopImmediatePropagation();this.open();this.refresh();},{capture:true});
   on(document,'mes:cart:open',()=>{this.open();this.refresh();});
   on(document,'mes:cart:network-added',()=>{if(!this.busy){this.open();this.refresh();}});
   // A custom PDP may redirect to /cart after adding. Render the drawer there too.
   const currentPath=location.pathname.replace(/\/$/,'');
   const cartPath=(this.dataset.root+'cart').replace(/\/$/,'');
   if(currentPath===cartPath) requestAnimationFrame(()=>{if(this.isConnected){this.open();this.refresh();}});
   if(this.dataset.intercept==='true')on(document,'submit',e=>{const form=e.target;if(!(form instanceof HTMLFormElement)||!form.querySelector('[name="id"]')||!new URL(form.action,location.href).pathname.match(/\/cart\/add(?:\.js)?$/))return;e.preventDefault();e.stopImmediatePropagation();if(this.busy)return;this.open();this.mutate('add',new FormData(form));},{capture:true});
   on(document,'shopify:section:select',e=>{if(e.detail.sectionId===this.dataset.section)this.open();});
  }
  open(){if(this.dialog.open)return;this.opener=document.activeElement;this.savedOverflow=document.body.style.overflow;document.body.style.overflow='hidden';this.dialog.showModal();this.querySelector('[data-close]').focus();}
  close(){this.dialog.close();}
  error(message){const p=this.querySelector('.mc-error');p.textContent=message;p.hidden=false;}
  async refresh(){const seq=++this.sequence;try{const u=new URL(this.dataset.root,location.origin);u.searchParams.set('sections',this.dataset.section);const response=await fetch(u,{cache:'no-store'});if(!response.ok)throw Error('Warenkorb konnte nicht geladen werden.');const data=await response.json();if(seq!==this.sequence)return;const doc=new DOMParser().parseFromString(data[this.dataset.section]||'','text/html');const content=doc.querySelector('[data-mc-content]');if(!content)throw Error('Warenkorb konnte nicht geladen werden. Bitte Seite neu laden.');const oldScroll=this.querySelector('.mc-scroll').scrollTop;const focused=this.contains(document.activeElement);this.querySelector('[data-mc-content]').replaceWith(content);this.querySelector('.mc-scroll').scrollTop=oldScroll;if(focused)this.querySelector('[data-close]').focus({preventScroll:true});document.querySelectorAll('[data-cart-count]').forEach(el=>{el.textContent=content.dataset.count;el.hidden=Number(content.dataset.count)===0;});}catch(e){this.error(e.message);}}
  async mutate(action,payload){if(this.busy)return;this.busy=true;this.querySelector('.mc-error').hidden=true;this.setAttribute('aria-busy','true');this.querySelectorAll('button:not([data-close])').forEach(b=>b.disabled=true);try{const form=payload instanceof FormData;const response=await fetch(this.dataset.root+'cart/'+action+'.js',{method:'POST',headers:form?{Accept:'application/json'}:{'Content-Type':'application/json',Accept:'application/json'},body:form?payload:JSON.stringify(payload)});const data=await response.json();if(!response.ok||data.status>=400)throw Error(data.description||data.message||'Der Warenkorb konnte nicht aktualisiert werden.');await this.refresh();document.dispatchEvent(new CustomEvent('mes:cart:updated'));}catch(e){this.error(e.message);}finally{this.busy=false;this.removeAttribute('aria-busy');this.querySelectorAll('button').forEach(b=>b.disabled=false);}}
  disconnectedCallback(){this.abort?.abort();if(this.dialog?.open)this.close();if(this.savedOverflow!==undefined)document.body.style.overflow=this.savedOverflow;}
 }
 customElements.define('mes-reference-cart',MesReferenceCart);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mes-category"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mes-shop-carousel'))customElements.define('mes-shop-carousel',class extends HTMLElement{
connectedCallback(){
this.controller=new AbortController();const o={signal:this.controller.signal};this.tabs=[...this.querySelectorAll('[data-tab]')];this.panels=[...this.querySelectorAll('[data-panel]')];
this.tabs.forEach((tab,i)=>{tab.addEventListener('click',()=>this.select(i),o);tab.addEventListener('keydown',e=>{let n=i;if(e.key==='ArrowRight')n=(i+1)%this.tabs.length;else if(e.key==='ArrowLeft')n=(i-1+this.tabs.length)%this.tabs.length;else if(e.key==='Home')n=0;else if(e.key==='End')n=this.tabs.length-1;else return;e.preventDefault();this.select(n);this.tabs[n].focus()},o)});
this.resize=new ResizeObserver(()=>this.update());
this.panels.forEach(panel=>{const track=panel.querySelector('.ms-track'),range=panel.querySelector('.ms-scroll');track.addEventListener('scroll',()=>this.sync(panel),{...o,passive:true});range.addEventListener('input',()=>{track.style.scrollSnapType='none';track.scrollLeft=(track.scrollWidth-track.clientWidth)*Number(range.value)/1000},o);range.addEventListener('change',()=>{track.style.scrollSnapType=''},o);track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();track.scrollBy({left:(e.key==='ArrowRight'?1:-1)*(track.querySelector('.ms-card')?.offsetWidth||200),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})}},o);this.resize.observe(track)});
document.addEventListener('shopify:block:select',e=>{const el=e.target.closest('[data-panel]');if(el)this.select(Number(el.dataset.panel));const tab=e.target.closest('[data-tab]');if(tab)this.select(Number(tab.dataset.tab))},o);this.update();
}
select(index){this.tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1});this.panels.forEach((panel,i)=>panel.hidden=i!==index);requestAnimationFrame(()=>this.update())}
sync(panel){if(panel.hidden)return;const t=panel.querySelector('.ms-track'),r=panel.querySelector('.ms-scroll'),max=t.scrollWidth-t.clientWidth;r.disabled=max<=1;r.value=max>0?String(t.scrollLeft/max*1000):'0';r.style.setProperty('--thumb',Math.min(100,Math.max(8,t.clientWidth/Math.max(1,t.scrollWidth)*100))+'%')}
update(){this.panels.forEach(panel=>this.sync(panel))}
disconnectedCallback(){this.controller?.abort();this.resize?.disconnect()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mes-collection"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mes-collection')) {
  customElements.define('mes-collection', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      const update = (key, value) => {
        const url = new URL(window.location.href);
        const collectionUrl = new URL(this.dataset.collectionUrl || url.pathname, url.origin);
        if (collectionUrl.pathname !== url.pathname) { url.pathname = collectionUrl.pathname; url.search = ''; }
        url.searchParams.delete('page');
        if (value === null) url.searchParams.delete(key);
        else url.searchParams.set(key, value);
        window.location.assign(url.toString());
      };
      this.querySelector('[data-mc-sort]')?.addEventListener('change', e => update('sort_by', e.target.value));
      this.querySelector('[data-mc-stock]')?.addEventListener('change', e => update('filter.v.availability', e.target.checked ? '1' : null));
      this.querySelectorAll('[data-mc-view]').forEach(button => button.addEventListener('click', () => {
        this.querySelector('.mc-grid')?.classList.toggle('mc-grid--large', button.dataset.mcView === 'large');
        this.querySelectorAll('[data-mc-view]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
      }));
      const tabs = [...this.querySelectorAll('[role="tab"]')];
      const selectTab = tab => {
        tabs.forEach(item => {
          const selected = item === tab;
          item.setAttribute('aria-selected', String(selected));
          item.tabIndex = selected ? 0 : -1;
          const panel = document.getElementById(item.getAttribute('aria-controls'));
          if (panel) panel.hidden = !selected;
        });
      };
      tabs.forEach((tab,index) => {
        tab.addEventListener('click', () => selectTab(tab));
        tab.addEventListener('keydown', event => {
          let next;
          if (event.key === 'ArrowRight') next = (index + 1) % tabs.length;
          if (event.key === 'ArrowLeft') next = (index - 1 + tabs.length) % tabs.length;
          if (event.key === 'Home') next = 0;
          if (event.key === 'End') next = tabs.length - 1;
          if (next === undefined) return;
          event.preventDefault(); selectTab(tabs[next]); tabs[next].focus();
        });
      });
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mes-hero"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mes-hero-media'))customElements.define('mes-hero-media',class extends HTMLElement{
  connectedCallback(){
    this.abort=new AbortController();const options={signal:this.abort.signal};
    this.slides=[...this.querySelectorAll('[data-slide]')];this.dots=[...this.querySelectorAll('[data-dot]')];this.index=0;this.paused=false;this.hovered=false;this.focused=false;
    this.motion=matchMedia('(prefers-reduced-motion: reduce)');
    this.querySelector('[data-prev]')?.addEventListener('click',()=>this.go(this.index-1),options);
    this.querySelector('[data-next]')?.addEventListener('click',()=>this.go(this.index+1),options);
    this.dots.forEach((dot,i)=>dot.addEventListener('click',()=>this.go(i),options));
    this.querySelector('[data-pause]')?.addEventListener('click',e=>{this.paused=!this.paused;e.currentTarget.setAttribute('aria-pressed',String(this.paused));e.currentTarget.textContent=this.paused?'▶':'Ⅱ';this.schedule()},options);
    this.addEventListener('mouseenter',()=>{this.hovered=true;this.schedule()},options);
    this.addEventListener('mouseleave',()=>{this.hovered=false;this.schedule()},options);
    this.addEventListener('focusin',()=>{this.focused=true;this.schedule()},options);
    this.addEventListener('focusout',e=>{this.focused=this.contains(e.relatedTarget);this.schedule()},options);
    this.querySelector('.mh-hero').addEventListener('keydown',e=>{if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();this.go(this.index+(e.key==='ArrowRight'?1:-1))}},options);
    let x=0,y=0;const hero=this.querySelector('.mh-hero');
    hero.addEventListener('touchstart',e=>{x=e.touches[0].clientX;y=e.touches[0].clientY},{...options,passive:true});
    hero.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-x,dy=e.changedTouches[0].clientY-y;if(Math.abs(dx)>50&&Math.abs(dx)>Math.abs(dy))this.go(this.index+(dx<0?1:-1))},{...options,passive:true});
    document.addEventListener('visibilitychange',()=>this.schedule(),options);
    this.motion.addEventListener('change',()=>this.schedule(),options);
    document.addEventListener('shopify:block:select',e=>{const i=this.slides.findIndex(s=>s.dataset.blockId===e.detail.blockId);if(i>=0){this.paused=true;this.go(i)}},options);
    this.schedule();
  }
  go(index){if(!this.slides.length)return;this.index=(index+this.slides.length)%this.slides.length;this.slides.forEach((slide,i)=>{const active=i===this.index;slide.classList.toggle('is-active',active);slide.inert=!active;slide.setAttribute('aria-hidden',String(!active))});this.dots.forEach((dot,i)=>dot.setAttribute('aria-current',String(i===this.index)));this.schedule()}
  schedule(){clearTimeout(this.timer);if(this.slides.length<2||this.dataset.autoplay!=='true'||this.paused||this.hovered||this.focused||document.hidden||this.motion.matches||window.Shopify?.designMode)return;this.timer=setTimeout(()=>this.go(this.index+1),Number(this.dataset.delay)||6000)}
  disconnectedCallback(){clearTimeout(this.timer);this.abort?.abort()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mes-image-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mes-creator-strip')) {
  customElements.define('mes-creator-strip', class extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.viewport = this.querySelector('.mcs-viewport');
      this.track = this.querySelector('.mcs-track');
      this.group = this.querySelector('.mcs-group');
      this.toggle = this.querySelector('.mcs-toggle');
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.stoppedUntil = 0;
      this.position = 0;
      const on = (el,type,fn) => el?.addEventListener(type,fn,{signal:this.abort.signal});
      on(this,'mouseenter',()=>this.hovered=true);
      on(this,'mouseleave',()=>this.hovered=false);
      on(this.viewport,'focusin',()=>this.focused=true);
      on(this.viewport,'focusout',()=>this.focused=false);
      on(this.viewport,'pointerdown',()=>{this.dragging=true;});
      on(window,'pointerup',()=>{if(this.dragging){this.dragging=false;this.stoppedUntil=performance.now()+3000;}});
      on(this.viewport,'wheel',()=>this.stoppedUntil=performance.now()+3000);
      on(this.toggle,'click',()=>{this.paused=!this.paused;this.paint();});
      on(this.motion,'change',()=>{this.paused=this.motion.matches;this.paint();});
      on(document,'shopify:block:select',event=>{
        if(this.contains(event.target)){this.paused=true;this.paint();event.target.scrollIntoView({block:'nearest',inline:'center'});}
      });
      this.observer=new ResizeObserver(()=>this.build());
      this.observer.observe(this.viewport);this.observer.observe(this.group);
      this.build();this.paint();
      if(this.dataset.editor==='true'){if(this.toggle)this.toggle.hidden=true;return;}
      this.tick=now=>{
        const delta=this.last ? Math.min(now-this.last,50) : 0;this.last=now;
        if(this.dataset.autoplay==='true'&&!this.paused&&!this.hovered&&!this.focused&&!this.dragging&&!document.hidden&&now>this.stoppedUntil&&this.cycle>0){
          this.position=(this.position+delta*Number(this.dataset.speed)/1000)%this.cycle;
          this.viewport.scrollLeft=this.position;
        }
        else {this.position=this.viewport.scrollLeft;}
        this.frame=requestAnimationFrame(this.tick);
      };
      this.frame=requestAnimationFrame(this.tick);
    }
    paint(){
      if(!this.toggle)return;
      this.toggle.setAttribute('aria-pressed',String(this.paused));
      this.toggle.setAttribute('aria-label',this.paused?this.toggle.dataset.playLabel:this.toggle.dataset.pauseLabel);
      this.toggle.firstElementChild.textContent=this.paused?'▶':'Ⅱ';
    }
    build(){
      this.track.querySelectorAll('[data-mcs-clone]').forEach(el=>el.remove());
      if(this.dataset.editor==='true'){this.cycle=0;return;}
      this.cycle=this.group.getBoundingClientRect().width;
      if(!this.cycle)return;
      const copies=Math.ceil(this.viewport.clientWidth/this.cycle)+1;
      for(let i=0;i<copies;i++){
        const clone=this.group.cloneNode(true);
        clone.dataset.mcsClone='';clone.setAttribute('aria-hidden','true');clone.inert=true;
        clone.querySelectorAll('*').forEach(el=>{
          el.removeAttribute('id');el.removeAttribute('data-shopify-editor-block');
        });
        this.track.append(clone);
      }
    }
    disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();cancelAnimationFrame(this.frame);}
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mes-limited-collection"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mes-limited-collection'))customElements.define('mes-limited-collection',class extends HTMLElement{
connectedCallback(){
this.abort=new AbortController();const o={signal:this.abort.signal};this.track=this.querySelector('.ml-track');this.range=this.querySelector('.ml-scroll');
this.track.addEventListener('scroll',()=>this.sync(),{...o,passive:true});
this.range.addEventListener('input',()=>{this.track.style.scrollSnapType='none';this.track.scrollLeft=(this.track.scrollWidth-this.track.clientWidth)*Number(this.range.value)/1000},o);
this.range.addEventListener('change',()=>{this.track.style.scrollSnapType=''},o);
this.track.addEventListener('keydown',e=>{if(e.target!==this.track||!['ArrowLeft','ArrowRight'].includes(e.key))return;e.preventDefault();this.track.scrollBy({left:(this.track.querySelector('.ml-card')?.offsetWidth+8||260)*(e.key==='ArrowRight'?1:-1),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})},o);
this.observer=new ResizeObserver(()=>this.sync());this.observer.observe(this.track);
document.addEventListener('shopify:block:select',e=>{if(this.contains(e.target)){const card=e.target.closest('.ml-card');if(card)this.track.scrollLeft=card.offsetLeft-this.track.offsetLeft}},o);this.sync();
}
sync(){const max=this.track.scrollWidth-this.track.clientWidth;this.range.hidden=max<2;this.range.value=max>0?String(this.track.scrollLeft/max*1000):'0';this.range.style.setProperty('--thumb',Math.min(100,Math.max(8,this.track.clientWidth/Math.max(this.track.scrollWidth,1)*100))+'%')}
disconnectedCallback(){this.abort?.abort();this.observer?.disconnect()}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mes-navigation"] && !Shopify.designMode) return;
  try {
    
(() => {
  if (customElements.get('mes-sticky-header')) return;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = window.matchMedia('(min-width: 990px)');
  const focusable = root => [...root.querySelectorAll('a[href],button,input,select,textarea,[tabindex="0"]')]
    .filter(el => !el.disabled && !el.closest('[inert]') && el.getClientRects().length);
  class Component extends HTMLElement {
    connectedCallback() { this.abort = new AbortController(); }
    on(target, type, fn, options = {}) {
      target.addEventListener(type, fn, { ...options, signal: this.abort.signal });
    }
    disconnectedCallback() { this.abort?.abort(); }
  }

  class SaleBar extends Component {
    connectedCallback() {
      super.connectedCallback();
      this.clock = this.querySelector('[data-clock]');
      this.end = Date.parse(this.dataset.end);
      this.on(this, 'click', async event => {
        if (event.target.closest('[data-sale-close]')) {
          this.hidden = true;
          const header = this.closest('mes-sticky-header');
          header?.style.setProperty('--announcement-height', '0px');
          header?.measure?.();
          return;
        }
        const button = event.target.closest('[data-copy]');
        if (!button) return;
        const status = this.querySelector('[data-sale-status]');
        let copied = false;
        try {
          if (!navigator.clipboard?.writeText) throw new Error('Clipboard unavailable');
          await navigator.clipboard.writeText(button.dataset.copy);
          copied = true;
        } catch (_) {
          const input = document.createElement('textarea');
          input.value = button.dataset.copy;
          input.style.cssText = 'position:fixed;top:0;left:0;opacity:0';
          this.append(input);input.focus();input.select();
          try { copied = document.execCommand('copy'); } catch (_) {}
          input.remove();button.focus();
        }
        status.textContent = copied ? status.dataset.success : status.dataset.error;
        if (copied) {
          const label = button.querySelector('span');
          label.textContent = status.dataset.success;
          clearTimeout(this.copyTimer);
          this.copyTimer = setTimeout(() => { label.textContent = button.dataset.copy; }, 2000);
        }
      });
      this.tick();
      if (Number.isFinite(this.end) && this.end > Date.now()) this.timer = setInterval(() => this.tick(), 1000);
    }
    tick() {
      if (!Number.isFinite(this.end)) { this.clock.hidden = true;return; }
      this.clock.hidden = false;
      const left = Math.max(0, Math.ceil((this.end - Date.now()) / 1000));
      const values = { days:Math.floor(left/86400), hours:Math.floor(left/3600)%24, minutes:Math.floor(left/60)%60, seconds:left%60 };
      Object.entries(values).forEach(([key,value]) => { this.querySelector('[data-'+key+']').textContent = String(value).padStart(2,'0'); });
      if (!left) clearInterval(this.timer);
    }
    disconnectedCallback() { clearInterval(this.timer);clearTimeout(this.copyTimer);super.disconnectedCallback(); }
  }
  class AnnouncementBar extends Component {
    connectedCallback() {
      super.connectedCallback();
      this.slides = [...this.querySelectorAll('[data-slide]')];
      this.index = 0;
      this.paused = false;
      this.hovered = false;
      this.focused = false;
      this.on(this, 'click', event => {
        if (event.target.closest('[data-prev]')) this.show(this.index - 1, true);
        if (event.target.closest('[data-next]')) this.show(this.index + 1, true);
        const pause = event.target.closest('[data-pause]');
        if (pause) {
          this.paused = !this.paused;
          pause.setAttribute('aria-pressed', String(this.paused));
          this.schedule();
        }
      });
      this.on(this, 'mouseenter', () => { this.hovered = true; this.schedule(); });
      this.on(this, 'mouseleave', () => { this.hovered = false; this.schedule(); });
      this.on(this, 'focusin', () => { this.focused = true; this.schedule(); });
      this.on(this, 'focusout', event => {
        if (!this.contains(event.relatedTarget)) { this.focused = false; this.schedule(); }
      });
      this.on(document, 'visibilitychange', () => this.schedule());
      this.on(reduced, 'change', () => this.schedule());
      this.on(document, 'shopify:block:select', event => {
        const i = this.slides.findIndex(slide => slide.contains(event.target));
        if (i >= 0) { this.show(i); this.paused = true; this.schedule(); }
      });
      this.querySelectorAll('[data-prev],[data-next]').forEach(button => { button.disabled = this.slides.length < 2; });
      this.schedule();
    }
    show(index, manual = false) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.querySelector('.mes-ann-slides').setAttribute('aria-live', manual ? 'polite' : 'off');
      this.slides.forEach((slide, i) => { slide.hidden = i !== this.index; slide.inert = i !== this.index; });
      this.schedule();
    }
    schedule() {
      clearTimeout(this.timer);
      if (this.dataset.autoplay !== 'true' || this.slides.length < 2 || this.paused || this.hovered || this.focused || reduced.matches || document.hidden) return;
      this.timer = setTimeout(() => this.show(this.index + 1), Number(this.dataset.interval) || 5000);
    }
    disconnectedCallback() { clearTimeout(this.timer); super.disconnectedCallback(); }
  }
  class MegaMenu extends Component {
    connectedCallback() {
      super.connectedCallback();
      this.button = this.querySelector('button');
      this.panel = this.querySelector('.mes-mega');
      this.positionPanel = () => {
        const bar = this.closest('.mes-bar');
        if (!bar) return;
        const rect = bar.getBoundingClientRect();
        this.panel.style.setProperty('--panel-left', `${-rect.left}px`);
        this.panel.style.setProperty('--panel-width', `${document.documentElement.clientWidth}px`);
      };
      this.on(window, 'resize', () => { if (this.opened) this.positionPanel(); });
      this.on(this.button, 'click', () => this.setOpen(!this.opened));
      this.on(this, 'pointerenter', event => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.setOpen(true), 150);
      });
      this.on(this, 'pointerleave', event => {
        if (event.pointerType !== 'mouse') return;
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
          if (!this.panel.contains(document.activeElement)) this.setOpen(false);
        }, 220);
      });
      this.on(this, 'focusout', event => {
        if (!this.contains(event.relatedTarget)) this.setOpen(false);
      });
      this.on(this, 'keydown', event => {
        if (event.key === 'Escape') {
          event.preventDefault(); this.setOpen(false); this.button.focus();
        }
        if (event.target === this.button && event.key === 'ArrowDown') {
          event.preventDefault(); this.setOpen(true); focusable(this.panel)[0]?.focus();
        } else if (this.panel.contains(event.target) && ['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) {
          const links = focusable(this.panel);
          const current = links.indexOf(document.activeElement);
          let next = event.key === 'Home' ? 0 : event.key === 'End' ? links.length - 1 : current + (event.key === 'ArrowDown' ? 1 : -1);
          event.preventDefault(); links[(next + links.length) % links.length]?.focus();
        }
      });
      this.on(document, 'pointerdown', event => { if (!this.contains(event.target)) this.setOpen(false); });
      this.on(desktop, 'change', () => { if (!desktop.matches) this.setOpen(false); });
    }
    setOpen(open) {
      clearTimeout(this.timer);
      if (open && !desktop.matches) return;
      if (open) this.closest('.mes-header').querySelectorAll('mes-mega-menu').forEach(menu => { if (menu !== this) menu.setOpen(false); });
      if (open) this.positionPanel();
      this.opened = open;
      this.button.setAttribute('aria-expanded', String(open));
      this.panel.inert = !open;
      this.classList.toggle('mes-mega-menu-open', open);
    }
    disconnectedCallback() { clearTimeout(this.timer); super.disconnectedCallback(); }
  }
  class Modal extends Component {
    connectedCallback() {
      super.connectedCallback();
      this.dialog = this.querySelector('dialog');
      this.on(this.dialog, 'cancel', event => { event.preventDefault(); this.close(); });
      this.on(this.dialog, 'close', () => this.restore());
      this.on(this.dialog, 'click', event => {
        if (event.target.closest('[data-close]')) this.close();
        if (event.target === this.dialog) {
          const r = this.dialog.getBoundingClientRect();
          if (event.clientX < r.left || event.clientX > r.right || event.clientY < r.top || event.clientY > r.bottom) this.close();
        }
      });
      this.on(this.dialog, 'keydown', event => {
        if (event.key !== 'Tab') return;
        const items = focusable(this.dialog), first = items[0], last = items[items.length - 1];
        if (!first) { event.preventDefault(); return; }
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });
    }
    open(trigger) {
      if (this.dialog.open) return;
      document.querySelectorAll('.mes-dialog[open]').forEach(dialog => dialog.parentElement.close?.(true));
      this.trigger = trigger;
      trigger?.setAttribute('aria-expanded', 'true');
      this.savedOverflow = document.body.style.overflow;
      this.savedPadding = document.body.style.paddingRight;
      const scrollbar = window.innerWidth - document.documentElement.clientWidth;
      if (scrollbar) document.body.style.paddingRight = `${parseFloat(getComputedStyle(document.body).paddingRight) + scrollbar}px`;
      document.body.style.overflow = 'hidden';
      this.locked = true;
      this.dialog.inert = false;
      this.dialog.showModal();
      this.frame = requestAnimationFrame(() => this.dialog.classList.add('is-open'));
      (this.dialog.querySelector('input[type="search"]') || focusable(this.dialog)[0])?.focus();
    }
    close(immediate = false) {
      if (!this.dialog.open) return;
      cancelAnimationFrame(this.frame);
      clearTimeout(this.closeTimer);
      this.dialog.classList.remove('is-open');
      if (immediate || reduced.matches) { this.dialog.close(); this.restore(); }
      else this.closeTimer = setTimeout(() => this.dialog.close(), 250);
    }
    restore() {
      if (!this.locked) return;
      this.dialog.inert = true;
      this.trigger?.setAttribute('aria-expanded', 'false');
      if (this.locked) {
        document.body.style.overflow = this.savedOverflow;
        document.body.style.paddingRight = this.savedPadding;
        this.locked = false;
      }
      if (this.trigger?.isConnected) this.trigger.focus({ preventScroll: true });
    }
    disconnectedCallback() {
      clearTimeout(this.closeTimer); cancelAnimationFrame(this.frame);
      if (this.dialog?.open) this.dialog.close();
      this.restore(); super.disconnectedCallback();
    }
  }
  class MenuDrawer extends Modal {
    connectedCallback() {
      super.connectedCallback();
      this.on(this, 'click', event => {
        const toggle = event.target.closest('.mes-accordion');
        if (!toggle) return;
        const panel = document.getElementById(toggle.getAttribute('aria-controls'));
        if (!panel) return;
        const open = toggle.getAttribute('aria-expanded') !== 'true';
        toggle.setAttribute('aria-expanded', String(open));
        panel.hidden = !open; panel.inert = !open;
      });
      this.on(desktop, 'change', () => { if (desktop.matches) this.close(true); });
    }
  }
  class LocalizationSelector extends Component {
    connectedCallback() {
      super.connectedCallback();
      this.on(this.querySelector('select'), 'change', () => this.querySelector('form').requestSubmit());
    }
  }
  class Search extends Modal {
    connectedCallback() {
      super.connectedCallback();
      this.input = this.querySelector('input[type="search"]');
      this.results = this.querySelector('[data-results]');
      this.status = this.querySelector('[data-status]');
      this.on(this.input, 'input', () => {
        clearTimeout(this.timer); this.request?.abort();
        this.results.replaceChildren(); this.status.textContent = '';
        const query = this.input.value.trim();
        if (query.length < 2) return;
        this.timer = setTimeout(() => this.suggest(query), 200);
      });
      this.on(this.input, 'keydown', event => {
        if (event.key === 'ArrowDown' && this.results.firstElementChild) {
          event.preventDefault(); this.results.firstElementChild.focus();
        }
      });
      this.on(this.results, 'keydown', event => {
        const links = [...this.results.querySelectorAll('a')];
        const i = links.indexOf(document.activeElement);
        if (event.key === 'ArrowDown') { event.preventDefault(); links[Math.min(i + 1, links.length - 1)]?.focus(); }
        if (event.key === 'ArrowUp') { event.preventDefault(); (links[i - 1] || this.input).focus(); }
      });
      this.on(this.dialog, 'close', () => { clearTimeout(this.timer); this.request?.abort(); });
    }
    async suggest(query) {
      this.request = new AbortController();
      const url = new URL(this.closest('.mes-header').dataset.searchUrl, location.origin);
      url.searchParams.set('q', query);
      url.searchParams.set('resources[type]', 'product');
      url.searchParams.set('resources[limit]', '6');
      this.results.setAttribute('aria-busy', 'true');
      try {
        const response = await fetch(url, { signal: this.request.signal, headers: { Accept: 'application/json' } });
        if (!response.ok) throw new Error('Search unavailable');
        const data = await response.json();
        if (this.input.value.trim() !== query) return;
        const products = data.resources?.results?.products || [];
        this.results.replaceChildren();
        products.forEach(product => {
          const target = new URL(product.url, location.origin);
          if (target.origin !== location.origin) return;
          const link = document.createElement('a');
          link.href = target.href; link.textContent = product.title;
          this.results.append(link);
        });
        this.status.textContent = products.length ? this.status.dataset.found : this.status.dataset.empty;
      } catch (error) {
        if (error.name !== 'AbortError') this.status.textContent = this.status.dataset.error;
      } finally { this.results.removeAttribute('aria-busy'); }
    }
    disconnectedCallback() { clearTimeout(this.timer); this.request?.abort(); super.disconnectedCallback(); }
  }
  class StickyHeader extends Component {
    connectedCallback() {
      super.connectedCallback();
      this.bar = this.querySelector('[data-bar]');
      this.announcement = this.querySelector('mes-sale-bar');
      this.lastY = Math.max(0, scrollY);
      this.direction = 0; this.distance = 0;
      this.on(window, 'scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => { this.frame = 0; this.update(); });
      }, { passive: true });
      this.on(window, 'resize', () => this.measure());
      this.on(this, 'focusin', () => this.hide(false));
      this.on(this, 'click', event => {
        const drawer = event.target.closest('[data-drawer-open]');
        if (drawer) { this.hide(false); this.querySelector('mes-menu-drawer').open(drawer); }
        const search = event.target.closest('[data-search-open]');
        if (search && !event.metaKey && !event.ctrlKey && !event.shiftKey) {
          event.preventDefault();
          const hook = new CustomEvent('mes:search-open', { bubbles: true, cancelable: true, detail: { trigger: search } });
          if (!this.dispatchEvent(hook)) return;
          const existing = [...document.querySelectorAll('details-modal')].find(el => el.querySelector('predictive-search'));
          const summary = existing?.querySelector('summary');
          if (summary) { if (!summary.parentElement.open) summary.click(); return; }
          this.querySelector('mes-search').open(search);
        }
        const skip = event.target.closest('[data-skip]');
        if (skip) {
          const main = document.querySelector('main, #MainContent, #main');
          if (main) { event.preventDefault(); main.setAttribute('tabindex', '-1'); main.focus(); main.scrollIntoView(); }
        }
      });
      this.on(document, 'cart:updated', event => {
        const cart = event.detail?.cart || event.detail;
        if (Number.isFinite(cart?.item_count)) { this.cartVersion = (this.cartVersion || 0) + 1; this.paintCart(cart.item_count); }
        else this.refreshCart();
      });
      this.on(window, 'pageshow', () => this.refreshCart());
      this.on(window, 'focus', () => this.refreshCart());
      this.on(document, 'visibilitychange', () => { if (!document.hidden) this.refreshCart(); });
      if ('PerformanceObserver' in window) {
        this.resources = new PerformanceObserver(list => {
          if (list.getEntries().some(entry => /\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(new URL(entry.name).pathname))) {
            clearTimeout(this.cartTimer); this.cartTimer = setTimeout(() => this.refreshCart(), 100);
          }
        });
        this.resources.observe({ entryTypes: ['resource'] });
      }
      this.observer = new ResizeObserver(() => this.measure());
      this.observer.observe(this.bar);
      if (this.announcement) this.observer.observe(this.announcement);
      this.measure(); this.refreshCart();
      document.fonts?.ready.then(() => { if (this.isConnected) this.measure(); });
    }
    measure() {
      this.removeAttribute('data-compact');
      const nav = this.querySelector('.mes-main-nav');
      const logo = this.querySelector('.mes-logo');
      if (desktop.matches && nav?.lastElementChild && nav.lastElementChild.getBoundingClientRect().right > logo.getBoundingClientRect().left - 16) this.setAttribute('data-compact', 'true');
      const height = this.bar.offsetHeight;
      document.documentElement.style.setProperty('--header-height', `${height}px`);
      document.documentElement.style.setProperty('--announcement-height', `${this.announcement?.offsetHeight || 0}px`);
      this.update();
    }
    update() {
      const y = Math.max(0, scrollY);
      const visible = Math.max(0, this.announcement?.getBoundingClientRect().bottom || 0);
      this.style.setProperty('--mes-ann-visible', `${visible}px`);
      this.classList.toggle('is-scrolled', y > 8);
      const delta = y - this.lastY;
      const direction = Math.sign(delta);
      if (direction && direction !== this.direction) this.distance = 0;
      this.distance += Math.abs(delta); this.direction = direction || this.direction;
      const busy = this.querySelector('dialog[open],.mes-mega-menu-open') || this.bar.contains(document.activeElement);
      if (this.dataset.sticky !== 'up' || y < 100 || busy) this.hide(false);
      else if (this.distance > 8) this.hide(direction > 0);
      this.lastY = y;
    }
    hide(hidden) { this.classList.toggle('is-hidden', hidden); this.bar.inert = hidden; }
    paintCart(count) {
      this.querySelectorAll('[data-cart-count]').forEach(badge => {
        badge.textContent = String(count);
        badge.hidden = count === 0 && this.dataset.showZero !== 'true';
      });
    }
    async refreshCart() {
      const version = this.cartVersion = (this.cartVersion || 0) + 1;
      this.cartRequest?.abort(); this.cartRequest = new AbortController();
      try {
        const response = await fetch(this.dataset.cartUrl, { signal: this.cartRequest.signal, cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        if (version === this.cartVersion && Number.isFinite(cart.item_count)) this.paintCart(cart.item_count);
      } catch (_) {}
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame); clearTimeout(this.cartTimer);
      this.cartRequest?.abort(); this.resources?.disconnect(); this.observer?.disconnect();
      super.disconnectedCallback();
    }
  }
  const components = {
    'sale-bar': SaleBar,
    'announcement-bar': AnnouncementBar,
    'mega-menu': MegaMenu,
    'menu-drawer': MenuDrawer,
    'localization-selector': LocalizationSelector,
    'search': Search,
    'sticky-header': StickyHeader
  };
  Object.entries(components).forEach(([name, component]) => {
    customElements.define(`mes-${name}`, component);
    if (name !== 'search' && !customElements.get(name)) customElements.define(name, class extends component {});
  });
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mes-product-page"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('mes-product-page')) {
  customElements.define('mes-product-page', class extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;

      this.abort = new AbortController();
      const signal = this.abort.signal;

      this.addEventListener('click', event => this.click(event), { signal });
      this.addEventListener('change', event => this.change(event), { signal });
      this.addEventListener('submit', event => this.submit(event), { signal });

      this.dialog = this.querySelector('dialog');

      this.dialog?.addEventListener('close', () => {
        document.documentElement.style.overflow = this.oldOverflow ?? '';
        this.zoomTrigger?.focus();
      }, { signal });

      this.snapshot = this.querySelector('[data-commerce]')?.innerHTML;
      this.syncPrice();
      this.observeButton();

      this.countObserver = new IntersectionObserver(entries => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;

          this.countObserver.unobserve(entry.target);

          const node = entry.target;
          const end = Number(node.dataset.count);

          if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;

          const start = performance.now();

          const tick = now => {
            if (!this.isConnected) return;

            const progress = Math.min((now - start) / 1300, 1);
            node.textContent = Math.round(end * (1 - Math.pow(1 - progress, 3)));

            if (progress < 1) requestAnimationFrame(tick);
          };

          requestAnimationFrame(tick);
        });
      }, { threshold: .5 });

      this.querySelectorAll('[data-count]').forEach(node => {
        this.countObserver.observe(node);
      });
    }

    disconnectedCallback() {
      this.abort?.abort();
      this.abort = null;
      this.variantRequest?.abort();
      this.countObserver?.disconnect();
      this.buttonObserver?.disconnect();

      if (this.dialog?.open) {
        document.documentElement.style.overflow = this.oldOverflow ?? '';
        this.dialog.close();
      }
    }

    click(event) {
      const thumb = event.target.closest('[data-thumb]');
      if (thumb) this.showMedia(thumb.dataset.thumb);

      const zoom = event.target.closest('[data-zoom]');

      if (zoom && this.dialog) {
        this.zoomTrigger = zoom;
        this.querySelector('[data-zoom-image]').src = zoom.dataset.src;
        this.oldOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.dialog.showModal();
      }

      if (event.target.closest('[data-close]') || event.target === this.dialog) {
        this.dialog?.close();
      }

      if (event.target.closest('[data-sticky-add]')) {
        const form = this.querySelector('.mp-form');
        const button = form?.querySelector('[data-add]');

        if (button && !button.disabled) form.requestSubmit(button);
      }

      const pause = event.target.closest('[data-pause]');

      if (pause) {
        const paused = pause.closest('.mp-press').classList.toggle('mp-paused');
        pause.setAttribute('aria-pressed', String(paused));
      }
    }

    change(event) {
      if (event.target.matches('[data-option]')) {
        this.variant(event.target);
      }

      if (event.target.name === 'selling_plan') {
        this.syncPrice();
      }

      if (event.target.matches('[data-review-filter]')) {
        const value = event.target.value;

        this.querySelectorAll('[data-review-rating]').forEach(node => {
          node.hidden = value !== 'all' && node.dataset.reviewRating !== value;
        });
      }
    }

    showMedia(id) {
      this.querySelectorAll('[data-media]').forEach(node => {
        node.hidden = node.dataset.media !== String(id);

        if (node.hidden) {
          node.querySelectorAll('video').forEach(video => video.pause());

          node.querySelectorAll('iframe').forEach(frame => {
            const src = frame.getAttribute('src');
            if (src) frame.setAttribute('src', src);
          });
        }
      });

      this.querySelectorAll('[data-thumb]').forEach(node => {
        node.setAttribute('aria-pressed', String(node.dataset.thumb === String(id)));
      });
    }

    syncPrice() {
      const choice = this.querySelector('input[name="selling_plan"]:checked');

      if (choice) {
        const price = Number(choice.dataset.price);
        const compare = Number(choice.dataset.compare);
        const money = choice.dataset.money || '';

        this.querySelector('[data-price]').textContent = money;

        const old = this.querySelector('[data-compare]');
        old.textContent = choice.dataset.compareMoney || '';
        old.hidden = !(compare > price);

        const badge = this.querySelector('[data-discount]');
        badge.hidden = !(compare > price);
        badge.textContent = compare > price
          ? '−' + Math.round((compare - price) * 100 / compare) + '%'
          : '';
      }

      const sticky = this.querySelector('[data-sticky-price]');

      if (sticky) {
        sticky.textContent = this.querySelector('[data-price]')?.textContent || '';
      }

      const button = this.querySelector('[data-add]');
      const stickyButton = this.querySelector('[data-sticky-add]');

      if (button && stickyButton) {
        stickyButton.disabled = button.disabled;
        stickyButton.textContent = button.textContent;
      }
    }

    async variant(input) {
      this.variantRequest?.abort();
      this.variantRequest = new AbortController();

      const request = this.variantRequest;

      const values = Array.from(
        this.querySelectorAll('[data-option]:checked'),
        node => node.value
      );

      const url = new URL(
        input.dataset.productUrl || this.dataset.url,
        location.origin
      );

      url.searchParams.set('option_values', values.join(','));

      if (url.pathname !== new URL(this.dataset.url, location.origin).pathname) {
        location.assign(url.href);
        return;
      }

      url.searchParams.set('section_id', this.dataset.section);

      const commerce = this.querySelector('[data-commerce]');
      const quantity = this.querySelector('[name="quantity"]:checked')?.value;
      const plan = this.querySelector('[name="selling_plan"]:checked')?.value;

      commerce.setAttribute('aria-busy', 'true');
      this.loadingVariant = true;
      this.querySelector('[data-add]').disabled = true;
      this.syncPrice();

      try {
        const response = await fetch(url, { signal: request.signal });
        if (!response.ok) throw new Error();

        const html = new DOMParser().parseFromString(
          await response.text(),
          'text/html'
        );

        const fresh = html.getElementById(this.id)?.querySelector('[data-commerce]');
        if (!fresh) throw new Error();
        if (request !== this.variantRequest) return;

        commerce.replaceWith(fresh);

        const quantityInput = Array.from(
          fresh.querySelectorAll('[name="quantity"]')
        ).find(node => node.value === quantity);

        if (quantityInput) quantityInput.checked = true;

        const planInput = Array.from(
          fresh.querySelectorAll('[name="selling_plan"]')
        ).find(node => node.value === plan);

        if (planInput) planInput.checked = true;

        fresh.querySelectorAll('input[type=radio]').forEach(node => {
          node.toggleAttribute('checked', node.checked);
        });

        this.snapshot = fresh.innerHTML;
        this.querySelector('[data-status]').textContent = '';

        this.syncPrice();
        this.showMedia(fresh.dataset.featured);
        this.observeButton();

        const page = new URL(location.href);
        page.searchParams.delete('option_values');

        if (fresh.dataset.variant) {
          page.searchParams.set('variant', fresh.dataset.variant);
        } else {
          page.searchParams.delete('variant');
          page.searchParams.set('option_values', values.join(','));
        }

        history.replaceState({}, '', page);

        Array.from(fresh.querySelectorAll('[data-option]'))
          .find(node => node.value === input.value)
          ?.focus({ preventScroll: true });
      } catch (error) {
        if (error.name === 'AbortError') return;

        commerce.innerHTML = this.snapshot;
        commerce.removeAttribute('aria-busy');
        this.querySelector('[data-status]').textContent = this.dataset.error;

        this.syncPrice();
        this.observeButton();
      } finally {
        if (request === this.variantRequest) this.loadingVariant = false;
      }
    }

    async submit(event) {
      if (!event.target.matches('.mp-form')) return;

      event.preventDefault();

      if (this.adding || this.loadingVariant) return;

      const form = event.target;
      const button = form.querySelector('[data-add]');

      if (button.disabled) return;

      this.adding = true;

      form.querySelectorAll('input').forEach(node => {
        node.dataset.wasDisabled = String(node.disabled);
      });

      const payload = new FormData(form);

      if (!payload.get('selling_plan')) {
        payload.delete('selling_plan');
      }

      form.querySelectorAll('input').forEach(node => {
        node.disabled = true;
      });

      this.querySelectorAll('[data-option]').forEach(node => {
        node.disabled = true;
      });

      button.disabled = true;
      form.setAttribute('aria-busy', 'true');
      this.syncPrice();

      const status = this.querySelector('[data-status]');
      status.textContent = '';

      try {
        const response = await fetch(this.dataset.root + 'cart/add.js', {
          method: 'POST',
          body: payload,
          headers: { Accept: 'application/json' }
        });

        const data = await response.json();

        if (!response.ok) {
          throw new Error(data.description || data.message || this.dataset.error);
        }

        status.textContent = this.dataset.added;
        this.querySelector('[data-cart-link]').hidden = false;

        try {
          const cartResponse = await fetch(this.dataset.root + 'cart.js', {
            headers: { Accept: 'application/json' }
          });

          if (cartResponse.ok) {
            const cart = await cartResponse.json();

            document.dispatchEvent(new CustomEvent('cart:updated', {
              detail: { cart, item_count: cart.item_count },
              bubbles: true
            }));
          }
        } catch (_) {}

        const sticky = this.querySelector('[data-sticky]');

        if (sticky && !sticky.hidden) {
          status.scrollIntoView({
            block: 'center',
            behavior: matchMedia('(prefers-reduced-motion: reduce)').matches
              ? 'auto'
              : 'smooth'
          });

          status.focus({ preventScroll: true });
        }
      } catch (error) {
        status.textContent = error.message || this.dataset.error;
        status.focus({ preventScroll: true });
      } finally {
        this.adding = false;

        form.querySelectorAll('input').forEach(node => {
          node.disabled = node.dataset.wasDisabled === 'true';
        });

        this.querySelectorAll('[data-option]').forEach(node => {
          node.disabled = false;
        });

        form.removeAttribute('aria-busy');
        button.disabled = this.querySelector('[data-commerce]').dataset.available !== 'true';
        this.syncPrice();
      }
    }

    observeButton() {
      this.buttonObserver?.disconnect();

      const sticky = this.querySelector('[data-sticky]');
      const button = this.querySelector('[data-add]');

      if (!sticky || !button) return;

      this.buttonObserver = new IntersectionObserver(entries => {
        const entry = entries[0];
        sticky.hidden = entry.isIntersecting || entry.boundingClientRect.top >= 0;
      }, { threshold: 0 });

      this.buttonObserver.observe(button);
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mes-technology-carousel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('mes-technology-carousel'))customElements.define('mes-technology-carousel',class extends HTMLElement{
connectedCallback(){
this.controller=new AbortController();const o={signal:this.controller.signal};this.track=this.querySelector('.ms-track');this.range=this.querySelector('.ms-scroll');
this.track.addEventListener('scroll',()=>this.sync(),{...o,passive:true});
this.range.addEventListener('input',()=>{this.track.style.scrollSnapType='none';this.track.scrollLeft=(this.track.scrollWidth-this.track.clientWidth)*Number(this.range.value)/1000},o);
this.range.addEventListener('change',()=>{this.track.style.scrollSnapType=''},o);
this.track.addEventListener('keydown',e=>{if(e.target!==this.track||!['ArrowLeft','ArrowRight'].includes(e.key))return;e.preventDefault();this.track.scrollBy({left:((this.track.querySelector('.ms-card')?.offsetWidth||250)+8)*(e.key==='ArrowRight'?1:-1),behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})},o);
this.observer=new ResizeObserver(()=>this.sync());this.observer.observe(this.track);
document.addEventListener('shopify:block:select',e=>{if(this.contains(e.target)){const card=e.target.closest('.ms-card');if(card)this.track.scrollLeft+=card.getBoundingClientRect().left-this.track.getBoundingClientRect().left}},o);
this.sync();
}
sync(){const max=this.track.scrollWidth-this.track.clientWidth;this.range.hidden=max<2;this.range.value=max>0?String(this.track.scrollLeft/max*1000):'0';this.range.style.setProperty('--thumb',Math.min(100,Math.max(5,this.track.clientWidth/Math.max(this.track.scrollWidth,1)*100))+'%')}
disconnectedCallback(){this.controller?.abort();this.observer?.disconnect()}
});

  } catch(e) { console.error(e); }
})();
})();
